import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {OAuthService} from 'angular-oauth2-oidc';
import {CustomsValidators} from '../../validators/custom.validators';
import {throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SarService {
  urlSarAz: string; // URL SAR API
  urlSarToken: string; // URL SAR TOKEN
  UrlLogout: string; // URL SAR logout
  constructor(private http: HttpClient, private oauthService: OAuthService) {
    this.UrlLogout = `${environment.bffBaseUrl}/sar/auth/logout/`;
    this.urlSarAz = `${environment.bffBaseUrl}/sar/groups/`;
    this.urlSarToken = `${environment.bffBaseUrl}/sar/auth`;
  }


  getModules() {
    const headersObject = new HttpHeaders().set('AzureToken', this.oauthService.getAccessToken());
    const urlBuilder = this.urlSarAz;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder, {
      headers: headersObject
    }) : throwError(CustomsValidators.msgNotValidUrl);
  }

  refreshToken() {
    const headersObject = new HttpHeaders().set('AzureToken', this.oauthService.getAccessToken());
    const item = {
      SARToken: sessionStorage.Token,
      RefreshToken: sessionStorage.RefreshToken,
    };
    const urlBuilder = `${environment.bffBaseUrl}/sar/auth/refresh`;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, item, {
      headers: headersObject
    }) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getToken() {
    const urlBuilder = this.urlSarToken;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  Logout() {
    const urlBuilder = this.UrlLogout;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, {SARToken: sessionStorage.Token})
      : throwError(CustomsValidators.msgNotValidUrl);
  }


}
